import React, { useState } from 'react'
import UserReport from '../ReportingGroup/UserReport/UserReport'
import CourseReport from '../ReportingGroup/CourseReport/CourseReport'
import { CourseReportProvider } from '../ReportingGroup/context/CourseReportContext'
import { UserReportProvider } from '../ReportingGroup/context/UserReportContext'
import Button from '../../../common/button/Button'

/**
 * I created and separated their context so that when we enable the shortcode capability on this one, they have their own data that's not connected to other report. I don't know if I'm thinking it right, correct it when you have better solution.
 */
const TableNav = ( { groupData, teamData, siteOptionsData } ) => {
    const [ currentLink, setCurrentLink ] = useState( 'course-report' )

    const contextProps = {
        props: groupData,
        teamData: teamData,
        siteData: siteOptionsData
    }

    const renderComponent = () => {
        switch( currentLink ){
            case 'course-report':
                return (
                    <CourseReportProvider>
                        <CourseReport {...contextProps} />
                    </CourseReportProvider>
                )
            case 'user-report':
                return (
                    <UserReportProvider>
                        <UserReport {...contextProps} />
                    </UserReportProvider>
                )
            default: 
                return(
                    <div>
                        Invalid type
                    </div>
                )
        }
    }
    return (
        <>
            <div className='msync-card__header'>
                <ul className='msync-card__navigation'>
                    <li>
                        <Button
                            className={`msync-button--is-style-link${currentLink === 'course-report' ? ' active' : ' msync-button--is-theme-secondary'}`} 
                            onClick={()=>setCurrentLink('course-report')}
                        >
                            <span>Course Report</span>
                        </Button>
                    </li>
                    <li>
                        <Button
                            className={`msync-button--is-style-link${currentLink === 'user-report' ? ' active' : ' msync-button--is-theme-secondary'}`} 
                            onClick={()=>setCurrentLink('user-report')}
                        >
                            <span>User Report</span>
                        </Button>
                    </li>
                </ul>
            </div>
            <div className='msync-card__body msync-card__body--has-table'>
                {
                    renderComponent()
                }        
            </div>
        </>
    )
}

export default TableNav
